import { useDropzone } from 'react-dropzone';

interface Props {
  onDrop?: (acceptedFiles: File[]) => void;
  acceptedFiles?: Record<string, string[]>;
  disabled?: boolean;
}

const useCustomFileUpload = (props: Props) => {
  const { onDrop, acceptedFiles, disabled } = props;
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    disabled,
    multiple: false,
    maxSize: 30000000,
    accept: acceptedFiles ?? {
      'image/*': ['.jpg', '.jpeg', '.png'],
      'application/pdf': ['.pdf'],
      // For Aghamir
      'application/vnd.ms-excel': [],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    },
  });

  const formatBytes = (bytes: number, decimals = 2) => {
    if (!+bytes) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  return {
    formatBytes,
    getRootProps,
    getInputProps,
  };
};

export default useCustomFileUpload;
